import { render, staticRenderFns } from "./RewardsSummary.vue?vue&type=template&id=043e1050&scoped=true"
import script from "./RewardsSummary.vue?vue&type=script&lang=js"
export * from "./RewardsSummary.vue?vue&type=script&lang=js"
import style0 from "./RewardsSummary.vue?vue&type=style&index=0&id=043e1050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043e1050",
  null
  
)

export default component.exports